import {ISheetRange, ISheetRangeList, SheetType} from '@mintdata/mint-kit/api/functions/SheetAPI';

export class SheetRangeListImpl implements ISheetRangeList
{
    constructor(public readonly ranges:ISheetRange[])
    {
    }

    public getType():SheetType
    {
        return SheetType.SheetRangeList;
    }

    public toString():string
    {
        return this.ranges.join(' | ');
    }
}
